import '@bootstrappers/graphql';
import {apolloProvider} from '@bootstrappers/graphql';
/************************************************************************
 * Import our bootstrappers
 ************************************************************************/
import '@bootstrappers/index';
/************************************************************************
 * Kick off the application
 ************************************************************************/
import listFeaturesQuery from '@gql/fetchFeatures.graphql';
import Vue from 'vue';
import App from './MainVueApp';
import router from './router';
// var PrettyError = require('pretty-error');
//
// // instantiate PrettyError, which can then be used to render error objects
// var pe = new PrettyError();
// pe.start();

window.vueApp = new Vue({
  el: '#app',
  apolloProvider,
  router,
  template: '<App/>',
  data: {
    ghosting: window.Application.ghosting, //Boolean(AuthManager.ghostedId),
    enabledFeatures: [],
  },
  methods: {
    stopGhosting() {
      window.location.href = '/ghost/stop';
    },
    startGhosting(id) {
      window.location.href = `/ghost/${id}`;
    },
    refreshFeatures() {
      console.log('refreshing features');
      apolloProvider.defaultClient.query({
        query: listFeaturesQuery,
        fetchPolicy: 'network-only',
      }).then(({ data: { currentUser: data } }) => {
          console.log('features refreshed');
          this.enabledFeatures = data.enabledFeatures;
        })
        .catch(error => {
          console.warn('Attempted to refresh features, however it failed');
          console.error(error);
        });
    },
  },
  mounted() {
    // if (AuthManager.hasValidToken) {
    //   this.refreshFeatures();
    // }
  },
  components: {
    App,
  },
});